import $ from 'jquery';

$(document).ready(function () {
  acfSuccessSliderBlock();
});

function acfSuccessSliderBlock() {
  $('.js-acf-success-slider-block').each(function () {
    $('.success-slider__list').slick({
      fade: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
    });
  });
}
